module.exports = __webpack_public_path__ + "img/sld_cs_1_og.67fde1ed.svg";